import { TextUtilities } from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@pwc/pwc-deals-ui';
import styles from './Avatar.module.scss';

type Props = {
  name: string;
  showTooltip?: boolean;
};

const Avatar = ({ name, showTooltip = true }: Props) => {
  const { t } = useTranslation();
  if (name) {
    const toolTipMessage = (user: string) => t('currentlyEditing', { user });
    const userList = name.split(' ');
    const firstName = userList[0];
    const lastName = userList[userList.length - 1];
    const initials = TextUtilities.getUserInitials(
      firstName,
      lastName
    ) as string;

    return (
      <div className={styles['avatar-wrapper']}>
        {showTooltip && (
          <Tooltip
            direction="bottom"
            tip={toolTipMessage(name)}
            dataTestId="avatar-testid"
            unthemed={false}
            showingInitial={false}
          >
            <div className={styles['avatar-wrapper__user-snippet']}>
              {initials}
            </div>
          </Tooltip>
        )}
        {!showTooltip && (
          <div className={styles['avatar-wrapper__user-snippet']}>
            {initials}
          </div>
        )}
      </div>
    );
  }
  return <></>;
};

export default Avatar;
